import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "snippet-html",
  "use": "snippet-html-usage",
  "viewBox": "0 0 78.53 53.59",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 78.53 53.59\" id=\"snippet-html\"><path fill=\"currentColor\" d=\"M78.53 26.86L59.2 53.59l-4.16-4.44 16.44-22.19L55 5.04 59.21 0l19.32 26.86M0 26.74L19.33 0l4.16 4.44L7.05 26.63l16.48 21.93-4.21 5.03L0 26.74\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/snippet-html.svg
// module id = yf7g
// module chunks = 39 44